import React, { Component } from 'react';
import MyTable from '../MyTable';

export default class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headings: [
        "id", "name", "title"
      ],
      loading: true,
      error: "",
      data: null
    };
  }

  loadData() {
    this.setState({ loading: true });

    const headers = {
      'Content-Type': 'application/json'
    };

    return axios
      .get(`/api/pages`, headers)
      .then(response => {
        this.setState({
          data: response.data.data,
          loading: false,
          error: false
        });
      })
      .catch(function(error) {
        this.setState({
          loading: false,
          error: `${error}`
        });
      });


  }

  componentDidMount(){
    this.loadData();
  }

  render(){

    const { loading, error, data, headings } = this.state;


    if (error) {
      return "ERROR";
    }
    else if (loading) {
      return "LOADING..."
    }
    else {
      return (
        <div>
          <MyTable headings={headings} data={data} url='/admin/dashboard/pages' actions={true} imageUpload={false} />
        </div>
      );
    }

  }

}
